import * as types from './types';

export const open = ({ componentIds }: { componentIds: number[] }) => ({
  type: types.OPEN,
  payload: { componentIds },
});

export const close = () => ({
  type: types.CLOSE,
});
